import { handleApiError } from "../../utils/apiErrorHandler";
import axiosInstance from "../../axiosConfig";
import { apiRequest } from "../../utils/async/apiRequest";

export const userLogin = async (payload) => {
  try {
    const res = await axiosInstance.post("/user-login", payload);
    return res;
  } catch (error) {
    return error;
  }
};

export const userChangePassword = async (payload) => {
  try {
    const res = await apiRequest({
      method: "post",
      apiEndpoint: `/user-change-password`,
      payload: { body: payload },
    });
    return res;
  } catch (error) {
    return error;
  }
};

export const varifyToken = async (payload) => {
  try {
    const res = await axiosInstance.post("/verify-token", payload);
    return res;
  } catch (error) {
    return error;
  }
};

export const setPassword = async (payload) => {
  try {
    const res = await apiRequest({
      apiEndpoint: "/status",
      payload: { body: payload },
      method: "post",
    });
    return res;
  } catch (error) {
    return error;
  }
};
